// extracted by mini-css-extract-plugin
export default {"toolTip":"toolTip-1-9cJ","toolTipText":"toolTipText-14kv6","toolTipIcon":"toolTipIcon-2CW-M"};